import { IDeductionTypeCategoriesRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetDeductionTypeCategoryUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IDeductionTypeCategoriesRepositoryResponse> {
    return this.lookupRepository.getDeductionTypeCategories();
  }
}
